import type { INotification, NotificationsActionTypes } from './Notifications.models';

export const notificationsReducer = (state: INotification[], action: NotificationsActionTypes) => {
  switch (action.type) {
    case 'ADD':
      return [...state, action.payload];
    case 'REMOVE':
      return state.filter((notification) => notification.id !== action.id);
    case 'REMOVE_ALL':
      return [];
    default:
      return state;
  }
};
